import { useWebApp } from "@vkruglikov/react-telegram-web-app";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { DEV_MODE, PROJECT_MODE } from "@/model/consts/common";
import { cn } from "@/model/utils";

import { ROUTERS } from "@/shared/constants/routers";
import { isMobileDevice } from "@/shared/lib/is-mobile-device";
import { getLocalStorage } from "@/shared/lib/local-storage";
import { LOCAL_STORAGE_VARIABLES } from "@/shared/lib/local-storage/constants/local-storage";
import ScrollToTop from "@/shared/lib/scroll-to-top";

import { ActiveExchangeBanner } from "@/widgets/active-exchange-banner";
import { Navbar } from "@/widgets/navbar";

export const Layout = () => {
  const navigate = useNavigate();
  const isMobile = isMobileDevice();
  const WebApp = useWebApp();

  useEffect(() => {
    const onboarded = getLocalStorage(LOCAL_STORAGE_VARIABLES.ONBOARDED);
    if (!onboarded) {
      navigate(ROUTERS.ONBOARDING);
    }
  }, []);

  useEffect(() => {
    if (
      ((!WebApp && !isMobile) || (WebApp && WebApp.version <= 6)) &&
      DEV_MODE === PROJECT_MODE.PROD_MODE
    ) {
      navigate(ROUTERS.ERROR);
    }
  }, [WebApp, isMobile, navigate]);

  return (
    <>
      <ScrollToTop />
      <div
        className={cn(
          "relative m-auto flex min-h-dvh max-w-(--maxWidth) flex-col overflow-hidden",
        )}
      >
        <div
          className={cn("flex flex-1 flex-col pt-8 pb-24", {
            "pt-24 pb-28": isMobile,
          })}
        >
          <div className="flex w-full flex-1 flex-col items-center">
            <ActiveExchangeBanner />
            <Outlet />
            <Navbar />
          </div>
        </div>
      </div>
    </>
  );
};
